import { FishSpecies } from "../data/fish_db";
import { useLang } from "../contexts/LangContext";
import { useLongPress } from "../hooks/useLongPress";
import { useState, useEffect } from "react";
import { storageService } from "../services/storage.service";

export default function FishCard({
  fish,
  onSelect,
  onLongPress,
}: {
  fish: FishSpecies;
  onSelect: () => void;
  onLongPress: () => void;
}) {
  const { lang } = useLang();
  const [showBothLanguages, setShowBothLanguages] = useState(true);

  useEffect(() => {
    storageService.getSettings().then(settings => {
      setShowBothLanguages(settings.surveyShowBothLanguageNames ?? true);
    }).catch(console.error);
  }, []);

  const longPressHandlers = useLongPress(
    () => onLongPress(),
    () => {onSelect()},
    600
  );
  
  return (
    <div
      className="flex flex-col justify-start rounded-xl overflow-hidden p-2 shadow-sm bg-gray-200 bg-opacity-75 backdrop-blur-md hover:shadow-lg transition duration-200"
      {...longPressHandlers}
      onContextMenu={e => e.preventDefault()}
    >
      <img
        src={fish.image_url}
        alt={fish.english_name}
        draggable={false}
        className="w-full aspect-[5/3] object-cover rounded-lg pointer-events-none select-none bg-white"
      />
      <div className="px-2 mt-2 text-lg font-bold text-gray-800">
        {showBothLanguages ? (
          <>
            {lang === "bn"
              ? fish.local_name || fish.english_name
              : fish.english_name || fish.local_name}
            {fish.local_name && fish.english_name && (
              <span className="text-sm font-normal text-gray-600">
                {" "}({lang === "bn" ? <span className="en-font">{fish.english_name}</span> : <span className="bn-font">{fish.local_name}</span>})
              </span>
            )}
          </>
        ) : (
          lang === "bn"
            ? fish.local_name || fish.english_name
            : fish.english_name || fish.local_name
        )}
      </div>
    </div>
  );
}
